import React, { ReactNode } from 'react';

interface IProps {
  title: string;
  children: ReactNode | ReactNode[];
}

function FormSection({ title, children }: IProps) {
  return (
    <fieldset className="modFormSection">
      <legend className="modFormSection__title">{title}</legend>
      <div className="modFormSection__content">{children}</div>
    </fieldset>
  );
}

export default FormSection;
